export default {
  campaigns: {
  },
  macros: {},
  bulkModifiers: [],
  status: {}
};